module.exports = __webpack_public_path__ + "media/images/techri-rectangle-36deef0353c947f11b524e9d73c27358.svg";